<div fxLayout="row" fxLayoutGap="50px">
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
        <img *ngIf="data?.photoUrlList" [src]="data?.photoUrlList[0]" class="shop-item-thumbnail"/>

        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
            <div class="price-box" fxFlex fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="5px">
                <span class="price-box-title">{{"BUY" | translate}}</span>
                <span class="line"></span>
                <span>{{data.buy}}</span>
            </div>

            <div class="price-box" fxFlex fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="5px">
                <span class="price-box-title">{{"SELL" | translate}}</span>
                <span class="line"></span>
                <span>{{data.sell}}</span>
            </div>
        </div>
    </div>

    <div fxLayout="column" fxLayoutGap="20px">
        <h3 class="rm-margin">{{data?.name}}</h3>
        <span>{{data?.description}}</span>
        <span class="yellow-line"></span>
        <span>{{data?.articleNumber}}</span>
        <span>{{data?.weight}}</span>
        <span>{{data | productDimension}}</span>
        <span>Made In</span>
        <span>In Stock</span>
    </div>




</div>
